"use client";

import { LoadingStep } from "./LoadingStep";
import type { LoadingOnboardingModalContentProps } from "./types";

/** H5 fullscreen / PC centered modal shell — see `openLoadingOnboardingModal`. */
export const LoadingOnboardingModalContent: React.FC<
  LoadingOnboardingModalContentProps
> = ({ onClose, backgroundSrc, rippleCentered, ringPeakOpacity }) => (
  <div
    className="h-full w-full overflow-hidden"
    data-testid="loading-onboarding-modal-view"
  >
    <LoadingStep
      layout="modal"
      backgroundSrc={backgroundSrc}
      ringPeakOpacity={ringPeakOpacity}
      rippleCentered={rippleCentered}
      onBack={() => {
        onClose?.("back");
      }}
      onClose={() => {
        onClose?.("close");
      }}
    />
  </div>
);
